







import { get } from 'lodash';
import { ProfitResult } from 'sp-common/src/types/opti/ProfitResult';
import { Save } from 'sp-common/src/types/opti/Save';
import { generateRandomString, getAppRelease } from 'sp-common/src/utils';
import Vue, { CreateElement } from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';

import { OptiState } from '@/store/modules/opti';
import { analyticsTrack } from '@/utils/usageAnalytics';

const opti = namespace('opti');

@Component
export default class Results extends Vue {
  @opti.State activeSave!: number;
  @opti.State saves!: Save[];
  @opti.State destinationContracts!: OptiState['destinationContracts'];
  @opti.State input!: OptiState['input'];
  @opti.State vessel!: OptiState['vessel'];
  @opti.State profitResults!: OptiState['profitResults'];
  @opti.Mutation setNotes: any;
  @opti.Getter inputDateRange!: string[];
  comments = '';
  pollKey = '';
  timeoutKey?: number;

  get notes() {
    const save = this.saves[this.activeSave];
    if (save) {
      return save.notes;
    }
    return '';
  }

  get anonResultsPayload() {
    if (!this.profitResults || !this.vessel) return {};
    const vesselSpeed = this.vessel.speed;
    const trips = this.profitResults.map((result: ProfitResult) => {
      const distance =
        result.deliveryVoyageAnalysis.theoretical.operations.distance;
      const canal = result.deliveryVoyageAnalysis.theoretical.operations.canal;

      return {
        distance,
        canal,
        inputDateRange: this.inputDateRange,
      };
    });
    return {
      vesselSpeed,
      trips,
    };
  }

  notesChanged(event: Event) {
    const value = get(event, 'target.value');
    this.setNotes({ newVal: value });
  }

  pollSubmitAnalytics(isAccurate: boolean) {
    analyticsTrack('OPTI_RESULTS_ACCURACY_POLL', {
      isAccurate,
      comments: this.comments,
      appVersion: getAppRelease(),
      payloadVersion: '1.0',
      data: this.anonResultsPayload,
    });
  }

  poll() {
    const key = generateRandomString(6);
    this.pollKey = key;
    this.$notification.info({
      message: 'Poll',
      duration: 0,
      placement: 'bottomRight',
      key,
      description: (h: CreateElement) => {
        return [
          h('div', 'Do you feel that the results are accurate?'),
          h('a-textarea', {
            props: {
              autoSize: { minRows: 2, maxRows: 2 },
              placeholder: 'Comments (optional)',
              value: this.comments,
            },
            on: {
              change: (e: Event) => {
                const value = get(e, 'target.value');
                this.comments = value;
              },
            },
          }),
        ];
      },
      btn: (h: CreateElement) => {
        return [
          h(
            'a-button',
            {
              props: {
                type: 'primary',
              },
              style: {
                marginRight: '20px',
              },
              on: {
                click: () => {
                  this.pollSubmitAnalytics(true);
                  this.$notification.close(key);
                },
              },
            },
            'Yes'
          ),
          h(
            'a-button',
            {
              props: {
                type: 'danger',
              },
              on: {
                click: () => {
                  this.pollSubmitAnalytics(false);
                  this.$notification.close(key);
                },
              },
            },
            'No'
          ),
        ];
      },
    });
  }

  mounted() {
    const timeoutKey = window.setTimeout(this.poll, 15000);
    this.timeoutKey = timeoutKey;
  }
  destroyed() {
    this.$notification.close(this.pollKey);
    if (this.timeoutKey) {
      window.clearTimeout(this.timeoutKey);
    }
  }
}
